(function () {
    'use strict';

    var module = angular.module('uwAgenda.search', ['uwAgenda.global']);

    module.config(['$stateProvider', SettingsConfig]);

    // constants
    module.constant('SearchResultEnum', {
        0: { name: "Appointment", value: 0 },
        1: { name: "Message", value: 1 },
        2: { name: "Task", value: 2 },
        3: { name: "User", value: 3 },
        4: { name: "ZipCodes", value: 4 }
    });

    function SettingsConfig($stateProvider) {
        $stateProvider
            .state('Home.Search', {
                url: 'Search?searchStr',
                templateUrl: '/app/search/templates/search.template.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                params: {
                    searchStr: '',
                    errorMessage: ''
                },
                data: {
                    requiresLogin: true
                },
                ncyBreadcrumb: {
                    label: "{{'search' | translate}}"
                }
            });
    }

})();